export default "__VITE_ASSET__eff1e53b__"